import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=90ac12e2&scoped=true"
import script from "./ReturnDialog.vue?vue&type=script&lang=js"
export * from "./ReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&id=90ac12e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ac12e2",
  null
  
)

export default component.exports